import { render, staticRenderFns } from "./preferentialSettings.vue?vue&type=template&id=b21488dc"
import script from "./preferentialSettings.vue?vue&type=script&lang=js"
export * from "./preferentialSettings.vue?vue&type=script&lang=js"
import style0 from "./preferentialSettings.vue?vue&type=style&index=0&id=b21488dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports